import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAppointmentCoachRole(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAppointmentCoachRole = (appointmentCoachRoleId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`appointment-coach-roles/${appointmentCoachRoleId}/`);
  };

  return useMutation(deleteAppointmentCoachRole, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['appointmentCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['appointmentPayRateLookups'],
      });
    },
  });
}
